import { Menu, MenuItemLine } from 'room/common/presentation/menu'
import { MicMenuItem } from 'features/microphone'
import ScreenShareMenuItem from 'features/screen-share/screen-share-with-permission-menu-item'
import { useSelector } from 'react-redux'
import { RootState } from 'common/redux'
import { FocusFeature, TrainingRoomPhase } from 'common/types'
import { selectEnabledFeatures } from 'room/common/redux'
import MiscPanelMenu from '../misc/misc-panel-menu'
import { useQuestions } from '../../features/questions'
import { selectFocusedFeature } from './redux'
import CamMenuItem from 'features/camera/camera-menu-item'
export const isFeatureAcive = (
	phase: TrainingRoomPhase,
	focusedFeature: FocusFeature,
	questionActive: boolean
): boolean => {
	return !(
		(phase === TrainingRoomPhase.INITIAL ||
			phase === TrainingRoomPhase.REVIEWING_TASKS) &&
		!focusedFeature &&
		!questionActive
	)
}

export const TraineeMenu = (): JSX.Element => {
	const focusedFeature = useSelector(selectFocusedFeature)
	const trainingRoomPhase = useSelector(
		(state: RootState) => state.room.trainingRoomPhase
	)
	const questions = useQuestions()
	// A boolean, not the list: `selectEnabledFeatures` builds a new array on
	// every call, which would re-render the menu on every dispatched event.
	const screenShareEnabled = useSelector((state: RootState) =>
		selectEnabledFeatures(state).includes('ScreenType')
	)

	const featureActive = isFeatureAcive(
		trainingRoomPhase,
		focusedFeature,
		questions.active
	)

	return (
		<Menu>
			<MicMenuItem />
			<CamMenuItem />
			{/* `MicMenuItem` and `CamMenuItem` already check their own features;
			    this one never did, and a stationary interaction scheme enables no
			    `ScreenType`. Online rooms enable it, so nothing changes there. */}
			{screenShareEnabled ? (
				<ScreenShareMenuItem canStart={!featureActive} />
			) : null}
			<MenuItemLine />
			<MiscPanelMenu />
		</Menu>
	)
}

export default TraineeMenu
